import { HeaderDescription, Tabs } from "@pickit/pickit-components";
import { SlotsProps } from "./types";
import "./slots.scss";
import SlotsDetailContainer from "./slotsDetail/SlotsDetailContainer";
import SlotsTemplatesContainer from "./slotsTemplates/SlotsTemplatesContainer";
import { useCallback } from "react";
import { SlotsTabs } from "reducers/types/slots";
import "./i18n";
import { useTranslation } from "react-i18next";

const tabs: Array<any & { id: SlotsTabs }> = [
  {
    title: "Turnos",
    id: "slots",
    icon: "document",
    testId: "slots-tab-detail",
  },
  {
    title: "Plantillas",
    id: "templates",
    icon: "calendar",
    testId: "slots-tab-templates",
  },
];

export const Slots: React.FC<SlotsProps> = ({
  actualPage,
  filters,
  testId,
  shouldRender,
  changePage,
  exportSlots,
}): JSX.Element => {
  const { t } = useTranslation();
  const renderActualTab = useCallback(() => {
    if (actualPage === "templates")
      return <SlotsTemplatesContainer testId="templates" />;
    if (actualPage === "slots")
      return <SlotsDetailContainer testId={`${testId}-detail`} />;
    return null;
  }, [actualPage, testId]);

  return (
    <div>
      <div className="slots-title">
        <HeaderDescription
          headline={t("slots:slots")}
          overline="Configuraciones"
          testId={`${testId}-title`}
        />
      </div>
      <Tabs
        tabs={tabs.map(({ title, icon, disabled, testId }) => ({ title, icon, disabled, testId }))}
        initialIndex={tabs.findIndex((t) => t.id === actualPage)}
        onChange={(action, index) => {
          action();
          changePage(tabs[index ?? 0].id);
        }}
        size="large"
        width="25%"
        align="left"
      >
        <>
          <></>
          <></>
        </>
      </Tabs>
      <div className="slots-page-header" />
      {shouldRender && renderActualTab()}
    </div>
  );
};
